export const GetAllProjectsInfo = `
query GetAllProjectsInfo(
    $tags: [Int],
    $traits:[String]
    $uids: [Int],
    $page: Int,
    $perpage: Int
    $orderby: OrderByEnum,
){
    homeposts(tags: $tags, page: $page, perpage: $perpage, uids:$uids, traits:$traits, orderby: $orderby){
      posts{
            postid
            creatoruid
            contenttime
            active
            published
            orderedpostparts {
              orderedpostpartid
              postpartid
              postpart {
                subtitle
                postparttype{
                    internalname
                  }
              }
            }
            title
            postmobilecover
            postthumbnailcover
            traits {
                name
                internalname
            }
        }
        totalCount
        pageCount
        page
    }
  }
`;
